import { Injectable, inject } from '@angular/core';
import { TostesStore } from 'src/app/store/tostes-store';
import { TostPositionEnum, TostTypeEnum } from 'src/app/shared/models/tostes.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  #tostesStore = inject(TostesStore);

  showError(message: { en: string; he: string }, seconds = 5): void {
    this.#tostesStore.addTost({
      guid: this.#tostesStore.generateGuid(),
      message,
      position: TostPositionEnum.BottomLeft,
      seconds,
      type: TostTypeEnum.ERROR,
    });
  }
}
